module.exports = __webpack_public_path__ + "static/media/ionic-ios-arrow-dropright.900c8446.svg";